function r(e){if(typeof e!="object"||e===null)return!1;let o=Object.getPrototypeOf(e);return o===null||o===Object.prototype}export{r as a};
